import { render, staticRenderFns } from "./good-table.vue?vue&type=template&id=6d00b180&"
import script from "./good-table.vue?vue&type=script&lang=js&"
export * from "./good-table.vue?vue&type=script&lang=js&"
import style0 from "./good-table.vue?vue&type=style&index=0&module=true&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports